import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const BODY_CLASS = 'text-[#6a6e6e] text-sm font-normal leading-[21px]'

export const TaxesContent = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Taxation'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} onDismiss={onDismiss}>
      <div className='flex flex-col gap-4'>
        <HelpDialogPassage accessibleLabel='Whenever you redeem a mutual fund, a portion of your returns is paid to the government as tax.'>
          <span className={BODY_CLASS}>
            Whenever you redeem a mutual fund, a portion of your returns is paid to the government as tax.
          </span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel='Taxes are applied as short-term/long-term capital gains or as per your income tax slab, depending on'>
          <span className={BODY_CLASS}>
            Taxes are applied as short-term/long-term capital gains or as per your income tax slab, depending on
          </span>
        </HelpDialogPassage>
        <ul className={`${BODY_CLASS} list-inside list-disc pl-2 m-0 flex flex-col gap-1`}>
          <li aria-label='the type of fund (equity fund, debt fund, etc)'>
            <span aria-hidden='true'>the type of fund (equity fund, debt fund, etc)</span>
          </li>
          <li aria-label='your holding period'>
            <span aria-hidden='true'>your holding period</span>
          </li>
        </ul>
      </div>
    </BottomSheetContent>
  )
}
